import React, { Component } from 'react'

class GeetestCaptcha extends Component {
  constructor(props) {
    super(props)
    this.state = {

    }
  }

  componentDidMount() {
    this.initGeetest4SDK()
    setTimeout(()=>{
      this.initVerityCode();
    }, 500)

  }

  initVerityCode(){
    if(window.initGeetest4){
    	window.initGeetest4(this.props.captchaConfig.config,this.props.captchaConfig.handler);
    }  
  }

  initGeetest4SDK() {
    (function () {
      try {
        let s = document.createElement("script");
        let x = document.getElementsByTagName("script")[0];
        s.type = "text/javascript";
        s.src = "https://www.dhresource.com/20220712/gt4.js";
        x.parentNode.insertBefore(s, x);
      } catch (e) { }
    })();

  }

  render() {
    return (
      <div className="captcha"></div>);
  }
}
export default GeetestCaptcha